// extracted by mini-css-extract-plugin
export var filterIncDec = "_dg-0";
export var leftBorder = "_dg-1";
export var rightBorder = "_dg-2";
export var stringInput = "_dg-3";